import React, { useContext, useEffect, useState } from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import * as d3 from 'd3'
import { isMobile } from 'react-device-detect'
import PageSection from '../components/PageSection'
import FocusChart from '../components/FocusChart'
import { monthAdd } from '../ultils/dateUtils'
import {
  MAX,
  ONE_YEAR,
  SIX_MONTHS,
  THREE_MONTHS,
  TWO_YEARS,
} from '../constants/FilterDateConstantValue'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { getDefaultMarketContextToggleObj } from '../ultils/riskOutlookToggleDefaults'

const SMALL_DESKTOP_HEIGHT = 850

const useStyles = makeStyles({
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
    marginTop: 5,
  },
  headerRowMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 12,
  },
  tabGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 18,
    borderBottom: '1px solid #DFE4EB',
  },
  tabGroupMobile: {
    flexWrap: 'wrap',
    gap: 12,
    marginTop: 10,
  },
  tabButton: {
    height: 32,
    paddingTop: 5,
    paddingBottom: 5,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '22px',
    letterSpacing: 0,
    color: '#757575',
    opacity: 1,
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    borderBottom: '2px solid transparent',
    marginBottom: -1,
  },
  tabButtonMobile: {
    height: 32,
    paddingTop: 5,
    paddingBottom: 5,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '22px',
    letterSpacing: 0,
    color: '#757575',
    opacity: 1,
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    borderBottom: '2px solid transparent',
    marginBottom: -1,
  },
  tabButtonActive: {
    color: '#181818',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '22px',
    letterSpacing: 0,
    borderBottom: '2px solid #1B3963',
  },
  toggleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
  },
  toggleGroupMobile: {
    flexWrap: 'wrap',
    gap: 10,
  },
  toggleItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
  },
  toggleDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
  },
  toggleLabel: {
    fontSize: 12,
    lineHeight: '18px',
    color: '#474747',
    fontWeight: 500,
  },
  switchTrack: {
    position: 'relative',
    display: 'inline-block',
    width: 36,
    height: 20,
    borderRadius: 999,
    background: '#E6EAF0',
    transition: 'background 0.2s ease',
    overflow: 'hidden',
  },
  switchTrackMobile: {
    position: 'relative',
    display: 'inline-block',
    width: 24,
    height: 12,
    borderRadius: 999,
    background: '#E6EAF0',
    transition: 'background 0.2s ease',
    overflow: 'hidden',
  },
  switchTrackActive: {
    background: '#1B3963',
  },
  switchThumb: {
    position: 'absolute',
    top: 2,
    left: 2,
    right: 'auto',
    width: 16,
    height: 16,
    borderRadius: '50%',
    background: '#FFFFFF',
    transition: 'left 0.2s ease, right 0.2s ease',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
  },
  switchThumbMobile: {
    position: 'absolute',
    top: 2,
    left: 2,
    right: 'auto',
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: '#FFFFFF',
    transition: 'left 0.2s ease, right 0.2s ease',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
  },
  switchThumbActive: {
    left: 'auto',
    right: 2,
  },
  subheading: {
    marginBottom: 10,
    fontSize: 14,
    color: '#474747',
    fontWeight: 600,
  },
  marketContextContainer: {
    borderTop: 'unset',
    background: '#fff',
    margin: 'unset !important',
    width: '100% !important',
    // '& .MuiGrid-item': {
    //   padding: '15px',
    // },
  },
  timeRange: {
    margin: '0 0px 25px 0px',
  },
  eventFeed: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #E8EBEF',
  },
  buttonGroup: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    color: '#474747',
    '& > div': {
      backgroundColor: '#F3F3F3',
      padding: '8px 12px',
      marginRight: 10,
      borderRadius: 20,
    },
  },
  bfaiBtn: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '& > div': {
      marginRight: 10,
      backgroundColor: '#3C5D9F',
      width: 16,
      height: 16,
      borderRadius: '50%',
    },
  },
  industryBtn: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '& > div': {
      marginRight: 10,
      backgroundColor: '#F8DC4F',
      width: 16,
      height: 16,
      borderRadius: '50%',
    },
  },
  chartContainer: {
    paddingLeft: '0px !important',
  },
  chartContainerMobile: {
    padding: '0px !important',
    border: 'none !important',
  },
  newsListContainer: {
    paddingRight: '0px !important',
    position: 'relative',
  },
  newsListContainerMobile: {
    padding: '0px !important',
  },
  blurBottom: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: 50,
    width: '100%',
    backgroundImage:
      'linear-gradient(180deg, rgba(255, 255, 255, 0) -10.75%, #FFFFFF 70.43%)',
  },
  minMaxRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    // marginBottom: 12,
  },
  minMaxRowMobile: {
    '& $minMaxLabel, & $minMaxValue': {
      fontSize: 12,
      lineHeight: '18px',
    },
  },
  minMaxItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 14,
    lineHeight: '22px',
  },
  minMaxLabel: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '22px',
    letterSpacing: 0,
    color: '#8C8C8C',
  },
  minMaxValue: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '22px',
    letterSpacing: 0,
    color: '#181818',
  },
  minMaxDivider: {
    width: 1,
    height: 16,
    background: '#E6EAF0',
  },
})

/**
 * @param {{
 *   tickerId: any,
 *   riskStatus: any,
 *   chartHeight?: number,
 *   chartContainerRef?: React.RefObject<HTMLDivElement>
 *   animateInitialDraw?: boolean
 * }} props
 */
const MarketContext = ({
  tickerId,
  riskStatus,
  chartHeight,
  chartContainerRef,
  animateInitialDraw = !isMobile,
} = {}) => {
  const classes = useStyles()
  const { state } = useContext(PortfolioContext)
  const [transform, setTransform] = useState(null) // for zoom
  const [selection, setSelection] = useState(null) // for brush
  const [selectedTime, setSelectedTime] = useState({
    title: isMobile ? ONE_YEAR : TWO_YEARS,
  })
  const [selectedRiskTab, setSelectedRiskTab] = useState('riskOutlook')
  const [contextChart, setContextChart] = useState(null)
  const [focusChart, setFocusChart] = useState(null)
  const [eventData, setEventData] = useState([])
  const [priceData, setPriceData] = useState([])
  const selectionRafRef = React.useRef(null)
  const [marketContextToggleObj, setMarketContextToggleObj] = useState(
    getDefaultMarketContextToggleObj,
  )

  const quickNoteEvents = React.useMemo(() => {
    const notesData = state?.notesData
    if (!notesData) return []

    const candidates = Array.isArray(notesData)
      ? notesData
      : Array.isArray(notesData?.history)
      ? notesData.history
      : Array.isArray(notesData?.note_history)
      ? notesData.note_history
      : Array.isArray(notesData?.notes_history)
      ? notesData.notes_history
      : Array.isArray(notesData?.signal_history)
      ? notesData.signal_history
      : Array.isArray(notesData?.signals)
      ? notesData.signals
      : Array.isArray(notesData?.data)
      ? notesData.data
      : notesData?.signal_overview || notesData?.signal_date || notesData?.date
      ? [notesData]
      : []

    if (candidates.length === 0) return []

    const parseDate = d3.timeParse('%Y-%m-%d')
    const formatDate = d3.timeFormat('%Y-%m-%d')

    const normalized = candidates
      .map(item => {
        const rawDate =
          item?.signal_date ??
          item?.date ??
          item?.p_date ??
          item?.created_at ??
          item?.createdAt
        let parsedDate = item?.date instanceof Date ? item.date : null
        if (!parsedDate && rawDate) {
          parsedDate = parseDate(rawDate) || new Date(rawDate)
        }
        if (!parsedDate || Number.isNaN(parsedDate.getTime())) {
          return null
        }

        const title =
          item?.signal_overview ?? item?.title ?? item?.note ?? item?.text ?? ''
        const rawDateLabel =
          item?.Date ??
          (rawDate instanceof Date ? formatDate(rawDate) : rawDate) ??
          formatDate(parsedDate)

        return {
          ...item,
          date: parsedDate,
          Date: rawDateLabel,
          title,
          isQuickNoteHistory: true,
          signal_type: item?.signal_type ?? 'Quick Note',
        }
      })
      .filter(Boolean)
      .sort((a, b) => a.date - b.date)
      .map((item, index) => ({
        ...item,
        id: item?.id ?? index,
      }))

    return normalized
  }, [state?.notesData])

  useEffect(() => {
    if (focusChart) {
      focusChart.toggleUpdate({ toggleProp: marketContextToggleObj })
    }
  }, [marketContextToggleObj, focusChart])

  const getDefaultRange = React.useCallback(() => {
    if (!priceData || priceData.length === 0) {
      return null
    }
    const rawLastDate = d3.max(priceData, d => d.date)
    const rawMinDate = d3.min(priceData, d => d.date)
    if (!rawLastDate || !rawMinDate) {
      return null
    }

    const lastDate = new Date(rawLastDate)
    const minDate = new Date(rawMinDate)
    lastDate.setDate(lastDate.getDate() + 1)
    let cutoffDate = new Date()
    switch (selectedTime?.title) {
      case THREE_MONTHS:
        cutoffDate = monthAdd(lastDate, -3)
        break
      case SIX_MONTHS:
        cutoffDate = monthAdd(lastDate, -6)
        break
      case ONE_YEAR:
        cutoffDate = monthAdd(lastDate, -12)
        break
      case TWO_YEARS:
        cutoffDate = monthAdd(lastDate, -24)
        break
      case MAX:
        cutoffDate = minDate
        break
      default:
        cutoffDate = minDate
        break
    }

    const fromDate = d3.max([minDate, cutoffDate])
    return [fromDate, lastDate]
  }, [priceData, selectedTime])

  useEffect(() => {
    if (!focusChart) return
    const range = getDefaultRange()
    if (!range) return
    const nextSelection = range.map(d => focusChart.x(d))
    setSelection(nextSelection)
    focusChart.brushed({ selection: nextSelection, sourceEvent: {} })
  }, [focusChart, getDefaultRange, chartHeight])

  useEffect(() => {
    if (isMobile) return undefined
    if (typeof window === 'undefined') return undefined
    if (window.innerHeight >= SMALL_DESKTOP_HEIGHT) return undefined
    if (!focusChart) return undefined

    let attempts = 0
    const maxAttempts = 8

    const tryApply = () => {
      const range = getDefaultRange()
      if (!range) return
      if (!focusChart.x || !focusChart.WIDTH) {
        if (attempts >= maxAttempts) return
        attempts += 1
        selectionRafRef.current = window.requestAnimationFrame(tryApply)
        return
      }
      const nextSelection = range.map(d => focusChart.x(d))
      if (nextSelection.some(v => Number.isNaN(v))) {
        if (attempts >= maxAttempts) return
        attempts += 1
        selectionRafRef.current = window.requestAnimationFrame(tryApply)
        return
      }
      setSelection(nextSelection)
      focusChart.brushed({ selection: nextSelection, sourceEvent: {} })
    }

    tryApply()
    return () => {
      if (selectionRafRef.current) {
        window.cancelAnimationFrame(selectionRafRef.current)
        selectionRafRef.current = null
      }
    }
  }, [focusChart, getDefaultRange, chartHeight])

  useEffect(() => {
    setPriceData(state.marketContext.priceData)
  }, [state.marketContext.priceData])

  useEffect(() => {
    if (selectedRiskTab === 'quickNote') {
      setEventData(quickNoteEvents)
      return
    }
    setEventData(state.marketContext.eventData)
  }, [selectedRiskTab, quickNoteEvents, state.marketContext.eventData])

  useEffect(() => {
    if (!focusChart) return
    if (transform) {
      if (transform?.transform?.applyX) {
        focusChart.zoomed(transform)
        return
      }
      if (transform?.applyX) {
        focusChart.zoomed({ transform })
        return
      }
    }
    if (selection) {
      focusChart.brushed({ selection, sourceEvent: {} })
    }
  }, [eventData, focusChart, transform, selection])

  const registerContextChartTimeChange = vis => {
    setContextChart(vis)
  }
  const registerFocusChartTimeChange = vis => {
    setFocusChart(vis)
  }

  const handleRiskTabChange = tab => {
    setSelectedRiskTab(tab)
    if (tab === 'riskOutlook') {
      setMarketContextToggleObj(prev => ({
        ...prev,
        showUnrecognisedRiskStatus: true,
        showRiskEvents: false,
        showNoteHistory: false,
      }))
      return
    }

    if (tab === 'quickNote') {
      setMarketContextToggleObj(prev => ({
        ...prev,
        showUnrecognisedRiskStatus: false,
        showRiskEvents: false,
        showNoteHistory: true,
      }))
      return
    }

    setMarketContextToggleObj(prev => ({
      ...prev,
      showUnrecognisedRiskStatus: false,
      showRiskEvents: true,
      showNoteHistory: false,
    }))
  }

  const toggleRiskOutlookFilter = key => {
    setMarketContextToggleObj(prev => ({
      ...prev,
      [key]: !prev[key],
    }))
  }

  const minPrice = React.useMemo(() => {
    if (!priceData || priceData.length === 0) return null
    return d3.min(priceData, d => d.Price)
  }, [priceData])

  const maxPrice = React.useMemo(() => {
    if (!priceData || priceData.length === 0) return null
    return d3.max(priceData, d => d.Price)
  }, [priceData])

  return (
    <PageSection
      title="Risk Events"
      subTitle="Identification of Risk Patterns"
      // customStyle={{ height: isMobile ? 'unset' : '573px' }}
      riskEventToolTip
      isShowingRisk={false}
      riskStatus={riskStatus}
      disableMinWidth
      customStyle={{ height: '100%' }}
      isCustom={true}
    >
      <></>
      <Grid className={classes.marketContextContainer} container spacing={2}>
        <Grid
          className={
            isMobile ? classes.chartContainerMobile : classes.chartContainer
          }
          item
          xs={12}
          sm={12}
        >
          <div
            className={clsx(classes.headerRow, {
              [classes.headerRowMobile]: isMobile,
            })}
          >
            <div
              className={clsx(classes.tabGroup, {
                [classes.tabGroupMobile]: isMobile,
              })}
            >
              <button
                type="button"
                className={clsx(
                  isMobile ? classes.tabButtonMobile : classes.tabButton,
                  {
                    [classes.tabButtonActive]:
                      selectedRiskTab === 'riskOutlook',
                  },
                )}
                onClick={() => handleRiskTabChange('riskOutlook')}
              >
                Risk Outlook
              </button>
              <button
                type="button"
                className={clsx(
                  isMobile ? classes.tabButtonMobile : classes.tabButton,
                  {
                    [classes.tabButtonActive]: selectedRiskTab === 'riskStory',
                  },
                )}
                onClick={() => handleRiskTabChange('riskStory')}
              >
                Risk Story History
              </button>
              <button
                type="button"
                className={clsx(
                  isMobile ? classes.tabButtonMobile : classes.tabButton,
                  {
                    [classes.tabButtonActive]: selectedRiskTab === 'quickNote',
                  },
                )}
                onClick={() => handleRiskTabChange('quickNote')}
              >
                Quick Note History
              </button>
            </div>
            {selectedRiskTab === 'riskOutlook' && (
              <div
                className={clsx(classes.toggleGroup, {
                  [classes.toggleGroupMobile]: isMobile,
                })}
              >
                <div
                  className={classes.toggleItem}
                  onClick={() =>
                    toggleRiskOutlookFilter('showRiskOutlookWatchlist')
                  }
                >
                  <span
                    className={classes.toggleDot}
                    style={{ background: '#E39193' }}
                  />
                  <span className={classes.toggleLabel}>Watchlist</span>
                  <span
                    className={clsx(
                      isMobile
                        ? classes.switchTrackMobile
                        : classes.switchTrack,
                      {
                        [classes.switchTrackActive]:
                          marketContextToggleObj.showRiskOutlookWatchlist,
                      },
                    )}
                    data-pdf-toggle="track"
                  >
                    <span
                      className={clsx(
                        isMobile
                          ? classes.switchThumbMobile
                          : classes.switchThumb,
                        {
                          [classes.switchThumbActive]:
                            marketContextToggleObj.showRiskOutlookWatchlist,
                        },
                      )}
                      data-pdf-toggle="thumb"
                    />
                  </span>
                </div>
                <div
                  className={classes.toggleItem}
                  onClick={() => toggleRiskOutlookFilter('showRiskSmoke')}
                >
                  <span
                    className={classes.toggleDot}
                    style={{ background: '#ED5F5F' }}
                  />
                  <span className={classes.toggleLabel}>Smoke</span>
                  <span
                    className={clsx(
                      isMobile
                        ? classes.switchTrackMobile
                        : classes.switchTrack,
                      {
                        [classes.switchTrackActive]:
                          marketContextToggleObj.showRiskSmoke,
                      },
                    )}
                    data-pdf-toggle="track"
                  >
                    <span
                      className={clsx(
                        isMobile
                          ? classes.switchThumbMobile
                          : classes.switchThumb,
                        {
                          [classes.switchThumbActive]:
                            marketContextToggleObj.showRiskSmoke,
                        },
                      )}
                      data-pdf-toggle="thumb"
                    />
                  </span>
                </div>
                <div
                  className={classes.toggleItem}
                  onClick={() => toggleRiskOutlookFilter('showRiskFire')}
                >
                  <span
                    className={classes.toggleDot}
                    style={{ background: '#DE1313' }}
                  />
                  <span className={classes.toggleLabel}>Fire</span>
                  <span
                    className={clsx(
                      isMobile
                        ? classes.switchTrackMobile
                        : classes.switchTrack,
                      {
                        [classes.switchTrackActive]:
                          marketContextToggleObj.showRiskFire,
                      },
                    )}
                    data-pdf-toggle="track"
                  >
                    <span
                      className={clsx(
                        isMobile
                          ? classes.switchThumbMobile
                          : classes.switchThumb,
                        {
                          [classes.switchThumbActive]:
                            marketContextToggleObj.showRiskFire,
                        },
                      )}
                      data-pdf-toggle="thumb"
                    />
                  </span>
                </div>
              </div>
            )}
          </div>
          <div
            className={clsx(classes.minMaxRow, {
              [classes.minMaxRowMobile]: isMobile,
            })}
          >
            <div className={classes.minMaxItem}>
              <span className={classes.minMaxLabel}>Min:</span>
              <span className={classes.minMaxValue}>
                {minPrice !== null
                  ? `${state?.marketContext?.currency} ${minPrice}`
                  : '-'}
              </span>
            </div>
            <span className={classes.minMaxDivider} />
            <div className={classes.minMaxItem}>
              <span className={classes.minMaxLabel}>Max:</span>
              <span className={classes.minMaxValue}>
                {maxPrice !== null
                  ? `${state?.marketContext?.currency} ${maxPrice}`
                  : '-'}
              </span>
            </div>
          </div>
          <div
            ref={chartContainerRef}
            style={{
              height:
                !isMobile && typeof chartHeight === 'number' && chartHeight >= 0
                  ? chartHeight
                  : '100%',
              minHeight:
                !isMobile && typeof chartHeight === 'number' && chartHeight >= 0
                  ? chartHeight
                  : 290,
              marginBottom: '10px',
            }}
          >
            <FocusChart
              data={priceData}
              events={eventData}
              tickerId={tickerId}
              animateInitialDraw={animateInitialDraw}
              toggleProps={marketContextToggleObj}
              registerFocusChartTimeChange={registerFocusChartTimeChange}
              selection={selection}
              transform={transform}
              setTransform={setTransform}
              currency={state?.marketContext?.currency}
              sizeTrigger={chartHeight}
            />
          </div>
        </Grid>
      </Grid>
    </PageSection>
  )
}

export default MarketContext
